import { render, staticRenderFns } from "./extensions.vue?vue&type=template&id=1a0b51f6"
import script from "./extensions.vue?vue&type=script&lang=js"
export * from "./extensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports